export default {
  title: 'FightCamp Trackers + Bag Extended Warranty - $79',
  id: 'fightcamp_trackers_bag_ext_warranty_79',
  price: 7900,
  category: 'warranty',
  description: 'Lengthen your coverage for 36 months',
  img_url: 'https://a.storyblok.com/f/152150/2000x2000/78c625b41a/fc-001-warranty-icon.png',
  marketplace_img_url: '',
};
